import { api, IWebSocketSendOptions } from 'core/api/ConnectionManager'
import {
    BeginSecondFactorActionRequest,
    BeginSecondFactorActionResponse,
    ConfirmAuthenticatorBindingRequest,
    ConfirmAuthenticatorBindingResponse,
    ConfirmSecondFactorActionRequest,
    ConfirmSecondFactorActionResult,
    FinalizeAuthenticatorBindingRequest,
    FinalizeAuthenticatorBindingResponse,
    SecondFactorStatus,
} from 'core/models/SecondFactor'

const quiet: IWebSocketSendOptions = { showEmitError: false }

export const secondFactorApi = {
    getSecondFactor: () => api.send<object, SecondFactorStatus>('getSecondFactor', {}),

    beginSecondFactorAction: (payload: BeginSecondFactorActionRequest) =>
        api.send<BeginSecondFactorActionRequest, BeginSecondFactorActionResponse>(
            'beginSecondFactorAction',
            payload,
            quiet
        ),

    confirmSecondFactorAction: (payload: ConfirmSecondFactorActionRequest) =>
        api.send<ConfirmSecondFactorActionRequest, ConfirmSecondFactorActionResult>(
            'confirmSecondFactorAction',
            payload,
            quiet
        ),

    confirmAuthenticatorBinding: (payload: ConfirmAuthenticatorBindingRequest) =>
        api.send<ConfirmAuthenticatorBindingRequest, ConfirmAuthenticatorBindingResponse>(
            'confirmAuthenticatorBinding',
            payload,
            quiet
        ),

    finalizeAuthenticatorBinding: (payload: FinalizeAuthenticatorBindingRequest) =>
        api.send<FinalizeAuthenticatorBindingRequest, FinalizeAuthenticatorBindingResponse>(
            'finalizeAuthenticatorBinding',
            payload,
            quiet
        ),
}
